import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  Box,
  Divider,
  Typography /* , InputAdornment, IconButton */,
  // Autocomplete,
  Grid,
  // CircularProgress,
} from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
import { PuceContext } from "context/AppContext";
import { ADMIN_PAYS_ROLE, SUPER_ADMIN_ROLE /* , AGENT_ROLE */ } from "constant/role";
import { checkRoleExist } from "utils/userInfos";
import servicesAPI from "services/servicesAPI";
/* import {
  filterDataUserByLevel,
  getUserbyRoleForm,
} from "services/userService";
import { PATH_USER_N4I } from "constant/moduleInfo"; */
import { ERROR } from "constant/message";
import LoadComponent from "components/LoadComponent";
import MDButton from "components/MDButton";
// import { PAGINATION_SIZE } from "constant";
// import useArrayOperation from "hooks/useArrayOperation";
import RepartitionPuceChart from "./RepartionPuceChart";

const LotPuceDetails = () => {
  const { REACT_APP_PHONE_NUMBER_LENGTH } = process.env;
  const puceContext = useContext(PuceContext);
  const { isAlert, isLoading, message, alertSeverity, handleLoad /* , getData */, putData } =
    servicesAPI();
  // const { customArrItem, sortArray } = useArrayOperation();
  const { selectedData /* , refresh */ } = puceContext;
  const [canEditAgent, setCanEditAgent] = useState(false);
  const [lotPuce /* , setLotPuce */] = useState(selectedData);
  // const [listAgent, setlistAgent] = useState([]);
  /* const [selectedAgent, setSelectedAgent] = useState({
    ...selectedData?.agent,
    ...{
      label: `${selectedData?.agent?.prenom ?? ""} ${selectedData?.agent?.nom ?? ""} - ${
        selectedData?.agent?.numTel ?? ""
      }`,
    },
  }); */
  const [agentNumTel, setAgentNumTel] = useState(selectedData?.agent?.numTel ?? "");

  const [openRepartitionPuceChart, setOpenRepartitionPuceChart] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [inputValue, setInputValue] = useState("");

  // console.log("ddd", selectedAgent);

  const handleEditAgent = async () => {
    if (agentNumTel.length !== 0 && agentNumTel.length !== Number(REACT_APP_PHONE_NUMBER_LENGTH)) {
      const loadData = {
        isAlert: true,
        message: "Veuillez saisir un numéro de téléphone valide pour l'agent",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
      return;
    }
    let loadData = {
      isAlert: true,
      message: "Modification de l'agent",
      isLoading: true,
      alertSeverity: "error",
    };
    handleLoad(loadData);
    const updateData = await putData(
      // `lot-puces/change-agent?numTel=&reference=${selectedData?.reference}`,
      `lot-puces/change-agent?numTel=${agentNumTel}&reference=${selectedData?.reference}`,
      {}
    );
    if (updateData !== ERROR) {
      setTimeout(() => {
        loadData = {
          isAlert: true,
          message: "Agent modifié avec succès",
          isLoading: false,
          alertSeverity: "success",
        };
        handleLoad(loadData);
      }, 200);
      /* const fetchData = await getData(`lot-puces/byReference?reference=${selectedData?.reference}`);
      if (fetchData !== ERROR) {
        setLotPuce(fetchData);
        refresh(fetchData);
      } */
    }
  };
  /* const fetchUser = async (roleName, currentRelatedUser) => {
    const listTargetRole = [{ role: roleName }];
    const data = await getUserbyRoleForm(getData, listTargetRole, 0, PAGINATION_SIZE);
    const filterData = await filterDataUserByLevel(data, PATH_USER_N4I);

    const filteredUser = filterData?.filter(
      (i) =>
        i?.lieu?.region === lotPuce?.lieu?.region &&
        i?.lieu?.departement === lotPuce?.lieu?.departement
    );
    // console.log("hh ", filteredUser);
    if (
      currentRelatedUser &&
      currentRelatedUser !== null &&
      Object.keys(currentRelatedUser).length !== 0 &&
      !filterData.some((i) => i.id === currentRelatedUser.id)
    ) {
      // eslint-disable-next-line no-param-reassign
      currentRelatedUser.userName = `${currentRelatedUser.prenom} ${currentRelatedUser.nom}`;
      filteredUser.push(currentRelatedUser);
    }
    const result = filteredUser.map((i) => {
      const item = {
        ...i,
        ...{
          label: `${i?.userName ?? ""} -  ${i?.numTel ?? ""}`,
        },
      };
      return item;
    });
    // console.log("ee", result);
    // return result;
    setlistAgent(result);
  }; */

  /* const fetchAgents = async (search) => {
    if (!search || search.length < 2) {
      setlistAgent([]);
      return;
    }

    try {
      setLoading(true);

      const fetchData = await getData(
        `Users/${AGENT_ROLE}?numTel=${search}&codeRegion=${
          lotPuce?.lieu?.codeRegion ?? ""
        }&codeDepartement=${lotPuce?.lieu?.codeDepartement ?? ""}&page=0&size=10`
      );
      let dataUser = [];
      if (
        fetchData !== ERROR &&
        Array.isArray(fetchData?.content) &&
        fetchData?.content?.length > 0
      ) {
        const customArr = customArrItem(fetchData?.content, MODULE_USER);
        dataUser = sortArray(customArr, "userName");
        console.log("fetch agent ", dataUser);
      }

      // etlistAgent(fetchData?.content);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents(inputValue);

    // return () => fetchAgents.cancel();
  }, [inputValue]); */
  useEffect(() => {
    const isAdminPays = checkRoleExist(ADMIN_PAYS_ROLE);
    const isSuperAdmin = checkRoleExist(SUPER_ADMIN_ROLE);
    if (isAdminPays || isSuperAdmin) {
      setCanEditAgent(true);
      // fetchUser(AGENT_ROLE, lotPuce?.agent);
    }
  }, []);
  /* useEffect(() => {
    setSelectedAgent({
      ...lotPuce?.agent,
      ...{
        label: `${lotPuce?.agent?.prenom ?? ""} ${lotPuce?.agent?.nom ?? ""} - ${
          lotPuce?.agent?.numTel
        }`,
      },
    });
  }, [lotPuce]); */

  return (
    <Box
      sx={{
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        margin: 2,
        position: "relative",
      }}
      style={{ backgroundColor: "white" }}
    >
      {/* <Box textAlign="center">
        <Typography variant="h6">Fiche de la puce</Typography>
      </Box> */}
      <TextField
        label="Reférence"
        name="reference"
        value={lotPuce?.reference ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="codeFabricant"
        label="Code Fabricant"
        value={lotPuce?.codeFabricant ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="fabricant"
        label="Fabricant"
        value={lotPuce?.fabricant ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="pays"
        label="Pays"
        value={lotPuce?.pays ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="categorie"
        label="Categorie"
        value={lotPuce?.categorie ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="typePuce"
        label="Type"
        value={lotPuce?.typePuce ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="status"
        label="Statut"
        value={lotPuce?.status ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="lieu"
        label="Lieu d'affectation"
        value={
          lotPuce?.lieu
            ? `${lotPuce?.lieu?.departement ?? ""} - ${lotPuce?.lieu?.region ?? ""}`
            : "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="adminDepartemental"
        label="Admin Departemental"
        value={`${lotPuce?.adminDepartemental?.prenom ?? ""}-${
          lotPuce?.adminDepartemental?.nom ?? ""
        }, ${lotPuce?.adminDepartemental?.numTel ?? ""}`}
        fullWidth
        margin="normal"
        disabled
      />
      {/* canEditAgent ? (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={listAgent}
          name="agent"
          value={selectedAgent ?? ""}
          noOptionsText="Aucune donnée disponible"
          // onChange={handleChangeFormValues}
          onChange={(event, newValue, reason) => {
            // console.log("ddd", reason, newValue);

            handleEditAgent(newValue);
            setSelectedAgent(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Agent"
            />
          )}
          // disabled={i.isdisabled}
        />
      ) : (
        <TextField
          name="agent"
          label="agent"
          value={`${lotPuce?.agent?.prenom ?? ""}-${lotPuce?.agent?.nom ?? ""}, ${
            lotPuce?.agent?.numTel ?? ""
          }`}
          // value={selectedAgent}
          fullWidth
          margin="normal"
          disabled
        />
      ) */}

      <Grid container spacing={2} sx={{ justifyContent: "center", alignItems: "center", m: 5 }}>
        <Grid item xs={12} sm={8}>
          <TextField
            fullWidth
            label="Téléphone de l'agent"
            value={agentNumTel}
            onChange={(e) => setAgentNumTel(e.target.value)}
            disabled={!canEditAgent}
            type="number"
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleEditAgent();
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} sx={{ display: "flex", alignItems: "center" }}>
          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            onClick={handleEditAgent}
            disabled={!canEditAgent}
          >
            Modifier l&apos;agent
          </MDButton>
        </Grid>
      </Grid>
      <Divider textAlign="center" />
      <Box textAlign="center">
        <Typography variant="h6">Repartition des puces par statut</Typography>
      </Box>
      <TextField
        label="Nombre total de puce"
        value={lotPuce?.totalPuce}
        fullWidth
        margin="normal"
        disabled
      />
      {lotPuce?.puceCount.map((i) => (
        <TextField
          key={i?.status}
          label={i?.status}
          // name="commune"
          // value={`${i?.count}  (${i?.percentage}%)`}
          value={`${i?.count}`}
          fullWidth
          margin="normal"
          disabled
        />
      ))}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
        <MDButton
          type="submit"
          variant="gradient"
          color="info"
          onClick={() => setOpenRepartitionPuceChart(true)}
          style={{ marginTop: 10 }}
        >
          Voir plus
        </MDButton>
      </div>
      {openRepartitionPuceChart && (
        <RepartitionPuceChart
          lotPuce={lotPuce}
          openAction={openRepartitionPuceChart}
          handleClose={setOpenRepartitionPuceChart}
        />
      )}
      <LoadComponent loadData={{ isAlert, isLoading, message, alertSeverity, handleLoad }} />
    </Box>
  );
};

export default LotPuceDetails;
